export type IconName =
  | "menu"
  | "close"
  | "globe"
  | "calendar"
  | "drag"
  | "edit"
  | "trash"
  | "expand"
  | "arrow-right"
  | "arrow-left"
  | "arrow-down"
  | "share"
  | "download"
  | "upload"
  | "summary"
  | "more"
  | "help"
  | "plane"
  | "train"
  | "bus"
  | "car"
  | "plus"
  | "map-pin"
  | "hotel"
  | "excursion"
  | "search"
  | "chevron-right"
  | "chevron-down"
  | "sun"
  | "moon";

const SVG_NS = "http://www.w3.org/2000/svg";

const PATHS: Record<IconName, string[]> = {
  menu: ["M4 6h16", "M4 12h16", "M4 18h16"],
  close: ["M6 6l12 12", "M18 6L6 18"],
  globe: [
    "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z",
    "M3 12h18",
    "M12 3a14 14 0 0 1 0 18",
    "M12 3a14 14 0 0 0 0 18",
  ],
  calendar: [
    "M19 4H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Z",
    "M16 2v4",
    "M8 2v4",
    "M3 10h18",
  ],
  drag: ["M9 6h.01", "M9 12h.01", "M9 18h.01", "M15 6h.01", "M15 12h.01", "M15 18h.01"],
  edit: [
    "M12 20h9",
    "M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4 12.5-12.5Z",
  ],
  trash: [
    "M3 6h18",
    "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
    "M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6",
    "M10 11v6",
    "M14 11v6",
  ],
  expand: [
    "M4 14v6h6",
    "M20 10V4h-6",
    "M14 10l6-6",
    "M10 14l-6 6",
  ],
  "arrow-right": ["M5 12h14", "M13 6l6 6-6 6"],
  "arrow-left": ["M19 12H5", "M11 18l-6-6 6-6"],
  "arrow-down": ["M12 5v14", "M6 13l6 6 6-6"],
  share: [
    "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8",
    "M16 6l-4-4-4 4",
    "M12 2v13",
  ],
  download: [
    "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
    "M7 10l5 5 5-5",
    "M12 15V3",
  ],
  upload: [
    "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
    "M17 8l-5-5-5 5",
    "M12 3v12",
  ],
  summary: [
    "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z",
    "M14 2v6h6",
    "M8 13h8",
    "M8 17h8",
    "M8 9h2",
  ],
  more: ["M12 6h.01", "M12 12h.01", "M12 18h.01"],
  help: [
    "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z",
    "M9.1 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3",
    "M12 17h.01",
  ],
  plane: [
    "M21 16v-2l-8-5V3.5a1.5 1.5 0 0 0-3 0V9l-8 5v2l8-2.5V19l-3 2v1l5-1 5 1v-1l-3-2v-5.5l8 2.5Z",
  ],
  train: [
    "M5 17V6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v11",
    "M5 12h14",
    "M8 7h8",
    "M7 21l2-2",
    "M17 21l-2-2",
    "M8 17h.01",
    "M16 17h.01",
  ],
  bus: [
    "M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Z",
    "M4 11h16",
    "M7 4V2",
    "M17 4V2",
    "M7 19v2",
    "M17 19v2",
    "M7 15h.01",
    "M17 15h.01",
  ],
  car: [
    "M5 17a2 2 0 1 0 4 0",
    "M15 17a2 2 0 1 0 4 0",
    "M3 17V11l2-5h14l2 5v6",
    "M3 11h18",
    "M7 11V7",
    "M17 11V7",
  ],
  plus: ["M12 5v14", "M5 12h14"],
  "map-pin": [
    "M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0Z",
    "M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
  ],
  hotel: [
    "M3 22h18",
    "M5 22V5h14v17",
    "M9 22v-7h6v7",
    "M9 8h2v3H9z",
    "M13 8h2v3h-2z",
    "M9 14h2v3H9z",
    "M13 14h2v3h-2z",
  ],
  // Compass — a day trip out of the city, distinct from the map-pin used for stops.
  excursion: [
    "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z",
    "M15.5 8.5l-2 5-5 2 2-5 5-2Z",
  ],
  search: ["M10.5 4a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13Zm5 11.5L20 20"],
  "chevron-right": ["m9 6 6 6-6 6"],
  "chevron-down": ["m6 9 6 6 6-6"],
  sun: [
    "M8 12a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
    "M12 2v2",
    "M12 20v2",
    "m4.93 4.93 1.41 1.41",
    "m17.66 17.66 1.41 1.41",
    "M2 12h2",
    "M20 12h2",
    "m6.34 17.66-1.41 1.41",
    "m17.66 6.34 1.41-1.41",
  ],
  moon: [
    "M20.354 15.354A9 9 0 0 1 8.646 3.646 9.003 9.003 0 0 0 12 21a9.003 9.003 0 0 0 8.354-5.646Z",
  ],
};

export function icon(
  name: IconName,
  opts: { size?: number; className?: string } = {},
): SVGSVGElement {
  const size = opts.size ?? 16;
  const svg = document.createElementNS(SVG_NS, "svg");
  svg.setAttribute("width", String(size));
  svg.setAttribute("height", String(size));
  svg.setAttribute("viewBox", "0 0 24 24");
  svg.setAttribute("fill", "none");
  svg.setAttribute("stroke", "currentColor");
  svg.setAttribute("stroke-width", "2.75");
  svg.setAttribute("stroke-linecap", "round");
  svg.setAttribute("stroke-linejoin", "round");
  svg.setAttribute("aria-hidden", "true");
  svg.setAttribute("focusable", "false");
  svg.classList.add("icon");
  if (opts.className) svg.classList.add(opts.className);

  for (const d of PATHS[name]) {
    const path = document.createElementNS(SVG_NS, "path");
    path.setAttribute("d", d);
    svg.appendChild(path);
  }
  return svg;
}
